import React, { useState, useEffect } from 'react'
import api from '../components/api'
//import Accordion from 'react-bootstrap/Accordion';
import Energia_DadosConsumo from '../components/Energia_DadosConsumo'
import Energia_DadosIniciativa from '../components/Energia_DadosIniciativa'
import Energia_EnvioPlanilha from '../components/Energia_EnvioPlanilha'
import Energia_DadosProducao from '../components/Energia_DadosProducao'
import Energia_GestaoEficiencia from '../components/Energia_GestaoEficiencia'


import ModalAmbiente from '../components/Energia_DadosProducao_Abas/modals/Ambiente'
import ModalAmbienteResumo from '../components/Energia_DadosProducao_Abas/modals/AmbienteResumo'


import ModalEnergiaEletricaResumo from '../components/Energia_DadosProducao_Abas/modals/EnergiaEletricaResumo'
import ModalEnergiaEletricaComprada from '../components/Energia_DadosProducao_Abas/modals/EnergiaEletricaComprada'
import ModalEnergiaEletricaGerada from '../components/Energia_DadosProducao_Abas/modals/EnergiaEletricaGerada'
import ModalEnergiaCombustivel from '../components/Energia_DadosProducao_Abas/modals/Combustivel'
import ModalEnergiaIluminacao from '../components/Energia_DadosProducao_Abas/modals/Iluminacao'
import ModalEnergiaHVACUnitario from '../components/Energia_DadosProducao_Abas/modals/HVACUnitario'
import ModalEnergiaHVACIndireta from '../components/Energia_DadosProducao_Abas/modals/HVACIndireta'
import ModalEnergiaHVACDireta from '../components/Energia_DadosProducao_Abas/modals/HVACDireta'
import ModalRefrigeracaoUnitario from '../components/Energia_DadosProducao_Abas/modals/RefrigeracaoUnitario'
import ModalRefrigeracaoCamara from '../components/Energia_DadosProducao_Abas/modals/RefrigeracaoCamara'
import ModalEnergiaAquecimento from '../components/Energia_DadosProducao_Abas/modals/Aquecimento'

import ModalIdentificacao from '../components/Energia_DadosProducao_Abas/modals/Identificacao'
import ModalGeradoresEstacionarios from '../components/Energia_DadosProducao_Abas/modals/GeradoresEstacionarios'
import ModalSADT from '../components/Energia_DadosProducao_Abas/modals/SADT'


import Correcoes from '../components/Correcoes'
import EmailCorrecoes from '../components/EmailCorrecoes'

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import moment from 'moment'


const Modal = (props) => {

    const [energia_id, setEnergia_id] = useState()
    var adesao_institucional_id = props.adesao_institucional_id
    var formulario_id = props.formulario_id
    var ano = props.ano


    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const [totalCorrecoes, setTotalCorrecoes] = useState(0)
    const [totalEmails, setTotalEmails] = useState(0)



    const verificaValidacoes = () => {

        
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            //console.log(dataPost, '1!')

            api.post('desafioValidaVarios', dataPost).then((result) => {

                

                if (result.data) {

                    setTotalCorrecoes(result.data.length)
                    
                }
                
              

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    const listaEmailsCorrecoes = () => {

        api.get(`emailsCorrecoesDesafio/${formulario_id}`).then((result) => {

            //console.log(result.data)
            setTotalEmails(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        verificaValidacoes()
        listaEmailsCorrecoes()
        

    }, [verificaDesafio, energia_id])
    

    async function carregaDados() {

        //console.log(adesao_institucional_id, ano)
        //return false

        await api.get(`energiaConsumo/${adesao_institucional_id}/${ano}`).then((result) => {

            //console.log(result.data, '!?')

            if (result.data) {


                var data = result.data[0]

                setEnergia_id(data.energia_id)
                console.log(data.energia_id)


            }

        }).catch((err) => { 

            console.log(err.response)

        })

    }
    

    function validaEnergia(opc) {


        var dataPost = {

            opc: opc,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            formulario_id: energia_id,

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma a ação?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
                    

                    api.put(`energiaValida`, dataPost).then((result) => {
                        
                        //console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$("#modalEnergia").modal('hide');
                            props.fnEnergia()

                        } else {

                            window.toastr.error(result.data.alerta)
                            return false
                        }

                        
                    }).catch((err) => {
                        console.log(err.response)
                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }





    async function geraPDF() {


        api.get(`energiaPDF/${adesao_institucional_id}/${ano}`).then((result) => {

            if (result.data.arquivo) {

                window.open(`https://cdn.hospitaissaudaveis.org/pdf/${result.data.arquivo}`)

            } else {

                window.toastr.error(`Não foi possível gerar o PDF, provavelmente o preenchimento não está completo!`)
                return false

            }

        }).catch((err) => {

            console.log(err.response)

        })


    }

    



    useEffect(() => {


        window.$('[href="#tabE1"]').tab('show');
        carregaDados()


    }, [ano, adesao_institucional_id])


    return (

        <div>


                <div className="modal fade" id="modalEnergia" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="true" data-focus="false" >
                    <div className="modal-dialog modal-lg" role="document" style={{ width: '95%'}} >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Desafio Energia - Ano {ano}</h1>
                            </div>
                            <div className="modal-body">
                                    
                                    <div className="panel-body">


                                    <div className="row">
                                        
                                        <div className="col-sm-12">
                                            


                                            <ul className="nav nav-tabs">
                                                    <li  className="active"><a href="#tabE1" data-toggle="tab">Gestão de Energia & Eficiência Energética</a></li>
                                                    <li style={{ display: 'none'}}><a href="#tabE6" data-toggle="tab">Consumo de Energia e Equipamentos</a></li>
                                                    <li style={{ display: 'none'}}><a href="#tabE2" data-toggle="tab">Iniciativas de Eficiência Energética</a></li>
                                                    <li style={{ display: 'none'}}><a href="#tabE3" data-toggle="tab">Planilha de apoio</a></li>
                                                    <li><a href="#tabE4" data-toggle="tab">Dados de Energia</a></li>
                                                    <li><a href="#tabE5" data-toggle="tab">Correções ({totalCorrecoes})</a></li>
                                                    <li><a href="#tabE7" data-toggle="tab">E-mails ({totalEmails})</a></li>
                                            </ul>

                                            <div className="tab-content">
                                                <div className="tab-pane fade in active" id="tabE1">
                                                    <div className="panel-body">

                                                        
                                                        <Energia_GestaoEficiencia adesao_institucional_id={adesao_institucional_id} ano={ano} energia_id={energia_id} />

                                                    </div>

                                                </div>
                                                <div className="tab-pane fade in" id="tabE6">
                                                    <div className="panel-body">

                                                    <Energia_DadosConsumo adesao_institucional_id={adesao_institucional_id} ano={ano} />

                                                    </div>

                                                </div>

                                                <div className="tab-pane fade in" id="tabE2">
                                                    <div className="panel-body">

                                                        <Energia_DadosIniciativa adesao_institucional_id={adesao_institucional_id} ano={ano} />

                                                    </div>

                                                </div>
                                                <div className="tab-pane fade in" id="tabE3">
                                                    <div className="panel-body">

                                                        <Energia_EnvioPlanilha adesao_institucional_id={adesao_institucional_id} ano={ano} />

                                                    </div>

                                                </div>
                                                <div className="tab-pane fade in" id="tabE4">
                                                    <div className="panel-body">

                                                        <Energia_DadosProducao adesao_institucional_id={adesao_institucional_id} ano={ano} energia_id={energia_id} />

                                                    </div>

                                                </div>
                                                <div className="tab-pane fade in" id="tabE5">
                                                    <div className="panel-body">

                                                        <Correcoes adesao_institucional_id={adesao_institucional_id} formulario_id={energia_id} ano={ano} origem="Energia" />

                                                    </div>

                                                </div>
                                                <div className="tab-pane fade in" id="tabE7">
                                                    <div className="panel-body">

                                                        <EmailCorrecoes adesao_institucional_id={adesao_institucional_id} formulario_id={energia_id} ano={ano}  origem="Resíduos" />
.
                                                    </div>

                                                </div>

                                                
                                            </div>

                                        </div>

                                    </div>


                                    </div>


                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger" onClick={() => geraPDF()}>PDF</button>
                                <button type="button" className="btn btn-info" onClick={() => validaEnergia('A')}>Em análise</button>
                                <button type="button" className="btn btn-danger" onClick={() => validaEnergia('P')}>Com pendências</button>
                                <button type="button" className="btn btn-primary" onClick={() => validaEnergia('V')}>Completo</button>
                                <button type="button" className="btn btn-warning" onClick={() => validaEnergia('Z')}>Verificado</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


                <ModalAmbiente energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>
                <ModalAmbienteResumo  energia_id={energia_id} />


                <ModalEnergiaEletricaComprada energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano} />
                <ModalEnergiaEletricaGerada energia_id={energia_id} adesao_institucional_id={adesao_institucional_id}  ano={ano} />
                <ModalEnergiaEletricaResumo  energia_id={energia_id} adesao_institucional_id={adesao_institucional_id}  ano={ano} />

                <ModalEnergiaCombustivel energia_id={energia_id} adesao_institucional_id={adesao_institucional_id}  ano={ano} />

                <ModalEnergiaIluminacao energia_id={energia_id} adesao_institucional_id={adesao_institucional_id}  ano={ano} />
                <ModalEnergiaHVACUnitario energia_id={energia_id} adesao_institucional_id={adesao_institucional_id}  ano={ano} />

                <ModalEnergiaHVACIndireta energia_id={energia_id} adesao_institucional_id={adesao_institucional_id}  ano={ano}/>
                <ModalEnergiaHVACDireta energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>
                
                <ModalRefrigeracaoUnitario energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>
                <ModalRefrigeracaoCamara energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>

                <ModalEnergiaAquecimento energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>

                <ModalIdentificacao energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>
                
                <ModalGeradoresEstacionarios energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>
                <ModalSADT energia_id={energia_id} adesao_institucional_id={adesao_institucional_id} ano={ano}/>

                               

        </div>


    )



}


    

export default Modal